module.exports = __webpack_public_path__ + "static/media/IMG_2198.da9bd476.jpg";